import { render, staticRenderFns } from "./activate-gift.vue?vue&type=template&id=1b05bea9&scoped=true"
import script from "./activate-gift.vue?vue&type=script&lang=js"
export * from "./activate-gift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b05bea9",
  null
  
)

export default component.exports